import confetti from 'canvas-confetti';
import { inject } from '@vercel/analytics';
import { injectSpeedInsights } from '@vercel/speed-insights';

injectSpeedInsights();
inject();
let currentProblem;
let gameMode = 'input';
let selectedNumbers = [];
let problems = [];
let correctAnswers = 0;
let totalAttempts = 0;
let timeLeft = Infinity;
let timerInterval;
let isUnlimited = true;
let totalQuestions = 0;
let currentQuestionNumber = 0;
let isChecking = false;
let isSoundMuted = localStorage.getItem('isSoundMuted') === 'true';
let answersHistory = {
    correct: [],
    wrong: []
};

function init() {
    const imageUrl = 'https://images.unsplash.com/photo-1695923142527-9b43a467b298?q=80&w=1600&auto=format&fit=crop&ixlib=rb-4.0.3';
// Preload image
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
        console.log('Image preloaded');
        document.getElementById('learnSection').style.backgroundImage=`url('${imageUrl}')`;
    };
}

init();

function updateTimer() {
    const timerElement = document.getElementById('time-left');
    const timerContainer = document.getElementById('timer');

    timerElement.textContent = timeLeft;

    // Remove any existing warning classes
    timerContainer.classList.remove('warning-mild', 'warning-severe');

    // Add appropriate warning class based on time left
    if (timeLeft <= 15 && timeLeft > 5) {
        timerContainer.classList.add('warning-mild');
    } else if (timeLeft <= 5) {
        timerContainer.classList.add('warning-severe');
    }

    // console.log("Time Left: "+timeLeft);
}

function setSelectedNumbers() {
    selectedNumbers = [];
    document.querySelectorAll('.checkbox-grid input[type="checkbox"]:checked').forEach(checkbox => {
        selectedNumbers.push(parseInt(checkbox.value));
    });

    localStorage.setItem('selectedNumbers', selectedNumbers);
}

function updateQuestionCounters() {
    document.getElementById('currentQuestion').textContent = currentQuestionNumber;
    document.getElementById('totalQuestions').textContent = totalQuestions;
}

function updateScoreDisplay() {
    document.getElementById('correct').textContent = correctAnswers;
    document.getElementById('incorrect').textContent = totalAttempts - correctAnswers;
}

function resetTimers() {
    setDifficulty(document.getElementById("difficulty").value);
}

function startTimer() {
    document.getElementById('timer').style.display = 'flex';
    timerInterval = setInterval(() => {
        timeLeft--;
        updateTimer();
        if (timeLeft <= 0) {
            clearInterval(timerInterval);
            endGame();
        }
    }, 1000);
}

function clearAnswersHistory() {
    answersHistory = {
        correct: [],
        wrong: []
    };
}

function resetAll(num){
    // Reset scores and history for new attempt
    correctAnswers = 0;
    totalAttempts = 0;
    currentQuestionNumber = 0; // Reset to 0
    totalQuestions = num
    clearInterval(timerInterval);
    clearAnswersHistory();

    // Update displays
    updateQuestionCounters();
    updateScoreDisplay();

    //reset timers
    resetTimers();
}

// Modify your existing displayResults function:
function displayResults() {
    const correctList = document.getElementById('correctAnswersList');
    const wrongList = document.getElementById('wrongAnswersList');
    const retryButton = document.getElementById('retryButton');
    const continueButton = document.getElementById('continueButton');

    const endAllQuestions = totalAttempts === totalQuestions;

    const timeUsed = getTimeLimit()-timeLeft;
    let messageOfAnswers = `עניתם על ${correctAnswers} שאלות נכון מתוך ${totalQuestions}`;
    if (!isUnlimited) {
        messageOfAnswers = `עניתם ב ${timeUsed} שניות  על ${correctAnswers} שאלות נכון מתוך ${totalQuestions}  `
    }
    document.querySelector('.final-score p').textContent = messageOfAnswers;
    // Add perfect score message if applicable
    const scoreMessage = document.querySelector('.final-score h2');
    if (answersHistory.wrong.length === 0 && totalAttempts === totalQuestions) {
        scoreMessage.textContent = "🌟 עניתם על הכל מושלם! 🌟";
        scoreMessage.classList.add('perfect-score');
        celebratePerfectScore();
    } else if (endAllQuestions || timeLeft <= 0) {
        scoreMessage.textContent = "התרגול הסתיים!";

        scoreMessage.classList.remove('perfect-score');
    } else { // user exit in the middle of the practice
        scoreMessage.textContent = "יש עוד שאלות לתרגל, קדימה בואו נמשיך";
        scoreMessage.classList.remove('perfect-score');
    }

    // Create correct answers section
    const correctSection = document.querySelector('.correct-answers');
    correctSection.style.display = answersHistory.correct.length > 0 ? 'block' : 'none';
    correctList.innerHTML = answersHistory.correct.map(item =>
        `<div class="answer-item correct-item">
            ${item.num1} × ${item.num2} = ${item.num1 * item.num2}
        </div>`
    ).join('');

    // Create wrong answers section
    const wrongSection = document.querySelector('.wrong-answers');
    wrongSection.style.display = answersHistory.wrong.length > 0 ? 'block' : 'none';
    wrongList.innerHTML = answersHistory.wrong.map(item =>
        `<div class="answer-item wrong-item">
        ${item.missingFactor
            ? `${item.num1} × <span class="wrong-answer">${item.userAnswer}</span> <span class="correct-solution">(${item.answer})</span> = ${item.num1 * item.num2}`
            : `${item.num1} × ${item.num2} = <span class="wrong-answer">${item.userAnswer}</span> <span class="correct-solution">(${item.answer})</span>`}
    </div>`
    ).join('');


    // Adjust layout if only one section is visible
    if (answersHistory.correct.length > 0 && answersHistory.wrong.length === 0) {
        correctSection.style.width = '100%';
    } else if (answersHistory.wrong.length > 0 && answersHistory.correct.length === 0) {
        wrongSection.style.width = '100%';
    }

    if (continueButton){
        continueButton.style.display = endAllQuestions || timeLeft <=0 ? 'none' : 'block';
    }

    // Show or hide retry button based on whether there are mistakes
    if (retryButton) {
        retryButton.style.display = endAllQuestions && answersHistory.wrong.length > 0  ? 'block' : 'none';
    }
}

// Modify your endGame function to ensure proper state reset:
function endGame() {
    displayResults();
    document.getElementById('backdrop').style.display = 'block';
    const modal = document.getElementById('finalScore');
    modal.style.display = 'block';
    modal.setAttribute('tabindex', '-1'); // Allows the modal to receive focus
    modal.focus();

}

function showNextProblem() {
    if (problems.length === 0) {
        clearInterval(timerInterval);
        endGame();
        return;
    }

    currentProblem = problems.pop();
    const prob = currentProblem.missingFactor ? `${currentProblem.num1} × ? = ${currentProblem.num1 * currentProblem.num2}` : `${currentProblem.num1} × ${currentProblem.num2} = ?`;

    document.getElementById('problem').textContent = prob;

    // Clear previous result
    document.getElementById('result').classList.add('hide');
    const questionCard = document.getElementById('questionCard');
    questionCard.classList.remove('correct-animation');
    questionCard.classList.remove('.wrong-animation');
    questionCard.classList.remove('.wrong-animation-input');

    // Show/hide appropriate input method based on mode
    const inputMode = document.getElementById('inputMode');
    const multipleChoiceMode = document.getElementById('multipleChoiceMode');
    if (gameMode === 'input') {
         inputMode.style.display = 'flex';
        multipleChoiceMode.style.display = 'none';

        // Setup input mode
        const answerInput = document.getElementById('answer');
        answerInput.value = '';
        answerInput.focus();
    } else {
        inputMode.style.display = 'none';
        multipleChoiceMode.style.display = 'flex';

        // Setup multiple choice mode
        const options = generateOptions(currentProblem);
        const optionsContainer = document.getElementById('answerOptions');
        optionsContainer.innerHTML = options.map((option, index) => `
            <button 
                class="answer-option" 
                data-value="${option.value}" 
                data-correct="${option.isCorrect}"
                onclick="checkMultipleChoice(this)"
            >
                ${option.value}
            </button>
        `).join('');
    }

}

// Function to play sound
function playSound(isCorrect) {
    if (isSoundMuted) return;

    try {
        const sound = document.getElementById(isCorrect ? 'correctSound' : 'wrongSound');
        if (sound) {
            sound.currentTime = 0; // Reset sound to start
            const playPromise = sound.play();

            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.log('Sound play failed:', error);
                });
            }
        }
    } catch (error) {
        console.log('Error playing sound:', error);
    }
}

function exitPractice() {
    // End the game and show results
    endGame();
}

function celebratePerfectScore() {
    const colors = ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'];
    const duration = 4000;
    const end = Date.now() + duration;

    if (!isSoundMuted) {
        const celebrationSound = document.getElementById('celebrationSound');
        celebrationSound.play().catch(e => console.log('Sound play failed:', e));
    }

    // Initial burst with all colors
    confetti({
        particleCount: 150,
        spread: 100,
        colors: colors,
        origin: { y: 0.7 }
    });

    // Continuous animation
    (function frame() {
        // Get two random colors for each burst
        const randomColors = colors.sort(() => Math.random() - 0.5).slice(0, 2);

        // Left cannon
        confetti({
            particleCount: 4,
            angle: 60,
            spread: 50,
            origin: { x: 0 },
            colors: randomColors
        });

        // Right cannon
        confetti({
            particleCount: 4,
            angle: 120,
            spread: 50,
            origin: { x: 1 },
            colors: randomColors
        });

        // Center bursts every 600ms
        if (Date.now() % 600 < 50) {
            confetti({
                particleCount: 40,
                spread: 80,
                colors: colors,
                origin: { y: 0.65 }
            });
        }

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    }());
}

function generateOptions(currentProblem) {
    const correctAnswer = currentProblem.answer;
    let options = new Set(); // Use Set to avoid duplicates

    // 1. Add correct answer
    options.add({
        value: correctAnswer,
        isCorrect: true,
        type: 'correct'
    });

    // 2. Add one number off by 1 (randomly choose +1 or -1)
    const offByOneValue = Math.random() < 0.5 ? correctAnswer + 1 : correctAnswer - 1;
    options.add({
        value: offByOneValue,
        type: 'off-by-one'
    });

    let adjacentOptions = currentProblem.missingFactor ? getHardModeOptions(currentProblem.answer) : getRegularModeOptions(currentProblem);

    // Shuffle adjacent options to randomize which ones we use
    adjacentOptions = adjacentOptions.sort(() => Math.random() - 0.5);

    // Add unique adjacent options until we have 4 total options
    for (let option of adjacentOptions) {
        if (options.size < 4 && !Array.from(options).some(opt => opt.value === option.value)) {
            options.add(option);
        }
    }

    // Convert to array and shuffle
    let finalOptions = Array.from(options);
    return finalOptions.sort(() => Math.random() - 0.5);
}
function getHardModeOptions(correctAns) {
    return [
        { value: correctAns + 1, type: 'plus-one' },
        { value: correctAns + 2, type: 'plus-two' },
        { value: correctAns - 1, type: 'minus-one' },
        { value: correctAns > 2 ? correctAns - 2 : correctAns + 3, type: 'minus-two' }
    ];
}

function getRegularModeOptions({ num1, num2, answer }) {
    return [
        { value: num1 * (num2 - 1), type: 'subjacent' },
        { value: (num1 - 1) * num2, type: 'subjacent-second' },
        { value: num1 * (num2 + 1), type: 'adjacent' },
        { value: (num1 + 1) * num2, type: 'adjacent-second' },
        { value: num1 * (num2 + 2), type: 'far-adjacent' },
        { value: answer + 2, type: 'off-by-two' }
    ];
}


function generateMultiplicationRows(num) {
    let rows = '';
    for (let i = 1; i <= 10; i++) {
        rows += `
            <div class="multiplication-row">
                ${num} × ${i} = ${num * i}
            </div>
        `;
    }
    return rows;
}

// Add this to your JavaScript file
function setupModalCloseOnBackdropClick() {
    // For message modal
    const messageModal = document.getElementById('messageModal');
    if (messageModal) {
        messageModal.onclick = function(event) {
            if (event.target === messageModal) {
                closeMessage();
            }
        };
    }

    // For end game modal and backdrop
    const finalScore = document.getElementById('finalScore');
    const backdrop = document.getElementById('backdrop');
    if (finalScore && backdrop) {
        backdrop.onclick = function() {
            closeResults();
        };
    }
}

function showMessage(message) {
    const modal = document.getElementById('messageModal');
    const messageText = document.getElementById('messageText');

    messageText.textContent = message;
    modal.style.display = 'flex';
}

// ---- PUBLIC

window.startPractice = function () {
    setSelectedNumbers();
    if (selectedNumbers.length === 0) {
        showMessage('יש לבחור לפחות לוח כפל אחד');
        return;
    }

    // Calculate total questions and reset counters
    resetAll(selectedNumbers.length * 10);

    // Generate problems
    problems = [];
    const isHardMode = document.getElementById('missingFactor').checked;
    gameMode = document.getElementById('multiChoice').checked ? 'multiChoice' : 'input';


    // set the questions
    for (let num of selectedNumbers) {
        for (let i = 1; i <= 10; i++) {
            if (isHardMode && Math.random() < 0.5) {
                problems.push({
                    num1: num,
                    num2: i,
                    multiplication: num * i,
                    answer: i,
                    missingFactor: true
                });
            } else {
                const first = Math.random() < 0.5 ? num : i;
                problems.push({
                    num1: first,
                    num2: (num * i) / first,
                    multiplication: num * i,
                    answer: num * i,
                    missingFactor: false
                });
            }
        }
    }

    problems = problems.sort(() => Math.random() - 0.5);

    if (!isUnlimited) {
        clearInterval(timerInterval);
        startTimer();
    }

    // Show practice section
    document.getElementById('configSection').classList.add('hidden');
    document.getElementById('practiceSection').classList.remove('hidden');
    document.getElementById('questionCard').style.display = 'flex';
    showNextProblem();
}

window.closeMessage = function () {
    document.getElementById('messageModal').style.display = 'none';
}

window.closeLearnMode = function () {
    document.querySelector('.flip-container').classList.remove('flip-to-learn');
    setTimeout(() => {
        // Hide learn section
        document.getElementById('learnSection').classList.add('hidden');
        // Show configuration section
        document.getElementById('configSection').classList.remove('hidden');
    }, 200);

}

window.startLearnMode= function () {
    // Set selected numbers
    setSelectedNumbers();

    if (selectedNumbers.length === 0) {
        showMessage('יש לבחור לפחות מספר אחד');
        return;
    }

    const learnSection = document.getElementById('learnSection');

    // Generate multiplication tables
    const learnContainer = learnSection.querySelector('.learn-container');
    learnContainer.innerHTML = selectedNumbers.map(num => `
        <div class="multiplication-table">
            <div class="table-title"><div class="table-title-header"> ${num}</div></div>
            ${generateMultiplicationRows(num)}
        </div>
    `).join('');

    document.querySelector('.flip-container').classList.add('flip-to-learn');
    setTimeout(() => {
        // Hide configuration section
        document.getElementById('configSection').classList.add('hidden');
        // Show learn section
        learnSection.classList.remove('hidden');
    }, 200);

}

window.checkAnswer = function() {
    if (isChecking) return; // If already checking, exit function
    isChecking = true; // Set flag to prevent multiple clicks/keypresses

    const answerInput = document.getElementById('answer');
    const checkButton = answerInput.nextElementSibling;
    const userAnswer = parseInt(answerInput.value);

    if (isNaN(userAnswer)){
        isChecking = false;
        return;
    }

    checkButton.disabled = true; // Disable button to prevent multiple clicks

    const resultDiv = document.getElementById('result');
    const questionCard = document.getElementById('questionCard');
    totalAttempts++;

    if (userAnswer === currentProblem.answer) {
        correctAnswers++;
        resultDiv.textContent = "נכון!";
        resultDiv.style.color = "green";
        questionCard.classList.add('correct-animation');
        playSound(true); // Play correct sound
        answersHistory.correct.push({
            num1: currentProblem.num1,
            num2: currentProblem.num2,
            answer: currentProblem.answer,
            missingFactor: currentProblem.missingFactor,
        });
    } else {
        resultDiv.textContent = "טעות!";
        resultDiv.style.color = "red";
        questionCard.classList.add('wrong-animation-input');
        playSound(false); // Play wrong sound
        answersHistory.wrong.push({
            num1: currentProblem.num1,
            num2: currentProblem.num2,
            answer: currentProblem.answer,
            missingFactor: currentProblem.missingFactor,
            userAnswer: userAnswer
        });
    }

    resultDiv.classList.remove('hide');
    updateScoreDisplay();
    currentQuestionNumber++;
    updateQuestionCounters();

    setTimeout(() => {
        questionCard.classList.remove('correct-animation');
        questionCard.classList.remove('wrong-animation-input');
        showNextProblem();
        checkButton.disabled = false;
        isChecking = false;
    }, 700);
}


// Function to toggle sound
window.toggleSound = function() {
    isSoundMuted = !isSoundMuted;
    const soundIcon = document.getElementById('soundIcon');
    soundIcon.classList.toggle('muted', isSoundMuted);
    soundIcon.classList.toggle('unmuted', !isSoundMuted);
    // Save preference to localStorage
    localStorage.setItem('isSoundMuted', isSoundMuted);
}

window.checkMultipleChoice = function(selectedButton) {
    const isCorrect = selectedButton.dataset.correct === 'true';
    const resultDiv = document.getElementById('result');
    const questionCard = document.getElementById('questionCard');
    totalAttempts++;

    if (isCorrect) {
        correctAnswers++;
        resultDiv.textContent = "נכון!";
        resultDiv.style.color = "green";
        selectedButton.classList.add('correct');
        questionCard.classList.add('correct-animation');
        playSound(true);
        answersHistory.correct.push({
            num1: currentProblem.num1,
            num2: currentProblem.num2,
            answer: currentProblem.answer,
            missingFactor: currentProblem.missingFactor,
        });
    } else {
        resultDiv.textContent = "טעות!";
        resultDiv.style.color = "red";
        selectedButton.classList.add('wrong');
        // Show correct answer
        document.querySelectorAll('.answer-option').forEach(button => {
            if (button.dataset.correct === 'true') {
                button.classList.add('correct');
            }
        });
        questionCard.classList.add('wrong-animation');
        playSound(false);
        answersHistory.wrong.push({
            num1: currentProblem.num1,
            num2: currentProblem.num2,
            answer: currentProblem.answer,
            missingFactor: currentProblem.missingFactor,
            userAnswer: parseInt(selectedButton.dataset.value)
        });
    }
    resultDiv.classList.remove('hide');
    // Disable all options to prevent multiple answers
    document.querySelectorAll('.answer-option').forEach(button => {
        button.disabled = true;
        if (button !== selectedButton && !button.classList.contains('correct')) {
            button.classList.add('hidden');
        }
    });

    updateScoreDisplay();
    currentQuestionNumber++;
    updateQuestionCounters();

    // Wait before showing next problem
    const timerLength = isCorrect ? 800 : 1600;
    setTimeout(() => {
        questionCard.classList.remove('correct-animation');
        questionCard.classList.remove('wrong-animation');
        showNextProblem();
    }, timerLength);
}

// Add a function to return to configuration from results
window.closeResults = function() {
    resetAll(0);
    document.getElementById('finalScore').style.display = 'none';
    document.getElementById('backdrop').style.display = 'none';
    document.getElementById('configSection').classList.remove('hidden');
    document.getElementById('practiceSection').classList.add('hidden');
}

window.resumeGame = function () {
    document.getElementById('questionCard').style.display = 'flex';
    document.getElementById('finalScore').style.display = 'none';
    document.getElementById('backdrop').style.display = 'none';
    document.getElementById('answer').focus();
}

window.retryMistakes = function() {
    // Create new problems array from wrong answers
    problems = answersHistory.wrong.map(item => ({
        num1: item.num1,
        num2: item.num2,
        answer: item.answer,
        missingFactor: item.missingFactor
    }));

    // Shuffle the problems
    problems = problems.sort(() => Math.random() - 0.5);

    resetAll(problems.length) // Set to number of mistakes

    // Hide the results modal and backdrop
    document.getElementById('finalScore').style.display = 'none';
    document.getElementById('backdrop').style.display = 'none';

    // Show the practice section
    document.getElementById('configSection').classList.add('hidden');
    document.getElementById('practiceSection').classList.remove('hidden');

    // Start the practice with the mistake problems
    document.getElementById('questionCard').style.display = 'flex';

    if (!isUnlimited) {
        clearInterval(timerInterval);
        startTimer();
    }

    showNextProblem();
}

window.setDifficulty = function(level) {
    isUnlimited = level === 'unlimited';
    document.getElementById('timer').style.display = isUnlimited ? 'none' : 'flex';

    switch(level) {
        case 'unlimited':
            timeLeft = Infinity;
            break;
        case 'easy':
            timeLeft = 90;
            break;
        case 'medium':
            timeLeft = 60;
            break;
        case 'hard':
            timeLeft = 30;
            break;
    }

    updateTimer();
}

function getTimeLimit() {
    const difficulty = document.getElementById('difficulty').value;
    switch(difficulty) {
        case 'easy': return 90;
        case 'medium': return 60;
        case 'hard': return 30;
        default: return null;
    }
}

// ----- LISTENERS
//  keyboard support for closing modals
document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
        // Close message modal if it's open
        const messageModal = document.getElementById('messageModal');
        if (messageModal.style.display === 'flex') {
            closeMessage();
        }

        // Close end game modal if it's open
        const finalScore = document.getElementById('finalScore');
        if (finalScore.style.display === 'block') {
            closeResults();
        }
    }
});
// Allow Enter key to submit answer
document.getElementById('answer').addEventListener('keyup', function(event) {
    if (event.key === 'Enter') {
        checkAnswer();
    }
});

// Better input handling for mobile
document.getElementById('answer').addEventListener('focus', function() {
    if (window.innerWidth < 768) {
        // Scroll the viewport to show the input field
        setTimeout(() => {
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
    }
});

// Add touch event handling
document.getElementById('answer').addEventListener('touchend', function(event) {
    event.preventDefault();
    this.focus();
});

// Improve modal scrolling on mobile
document.getElementById('finalScore').addEventListener('touchmove', function(event) {
    event.stopPropagation();
}, { passive: true });

// Initialize sound preference
document.addEventListener('DOMContentLoaded', () => {
    // Exit button listener
    document.getElementById('exitButton').addEventListener('click', exitPractice);

    // Sound initialization
    const soundIcon = document.getElementById('soundIcon');
    soundIcon.classList.toggle('muted', isSoundMuted);
    soundIcon.classList.toggle('unmuted', !isSoundMuted);

    // Retrieve the stored checked checkboxes from localStorage
    const storedNumbers = localStorage.getItem('selectedNumbers');
    selectedNumbers = storedNumbers ? storedNumbers.split(',') : ['2']; // 2 is the default check box
    // Checkbox prevention for last checked
    const checkboxes = document.querySelectorAll('.checkbox-grid input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
        checkbox.checked = selectedNumbers.includes(checkbox.value);
        checkbox.addEventListener('click', function(event) {
            const checkedCount = document.querySelectorAll('.checkbox-grid input[type="checkbox"]:checked').length;

            if (!this.checked && checkedCount === 0) {
                event.preventDefault();
                showMessage('יש לבחור לפחות מספר אחד');
            }
        });
    });

    // Set checkbox
    const multiChoiceCheckbox = document.getElementById("multiChoice");
    const advancedCheckbox = document.getElementById("missingFactor");


    // If the saved mode is "multiple", mark the checkbox as checked
    multiChoiceCheckbox.checked = localStorage.getItem("gameMode") === "multiChoice";
    advancedCheckbox.checked = localStorage.getItem("isAdvanced") === "Yes";

    // Add event listener to the checkbox
    multiChoiceCheckbox.addEventListener("change", (e) =>
        localStorage.setItem("gameMode", e.target.checked ? "multiChoice" : "input")
    );

    // Add event listener to the checkbox
    advancedCheckbox.addEventListener("change", (e) => {
        localStorage.setItem("isAdvanced", e.target.checked ? "Yes" : "No")
    });

    // select drop down init
    const selectElement = document.getElementById('difficulty');
    const savedDifficulty = localStorage.getItem('difficulty');

    if (savedDifficulty) {
        selectElement.value = savedDifficulty; // Set the select value
    }

    // 2. Save the value to localStorage on change
    selectElement.addEventListener('change', (e) => {
        localStorage.setItem('difficulty', e.target.value); // Store in localStorage
    });

    setupModalCloseOnBackdropClick();
});

// // Prevent double-tap zoom on iOS
// document.addEventListener('touchend', function(event) {
//     event.preventDefault();
//     event.target.click();
// }, false);

// Prevent zoom when focusing input on iOS
document.addEventListener('gesturestart', function(event) {
    event.preventDefault();
});


